// import Vue from 'vue'
export const UPDATE_SETTING = (state, param) => {
    state.setting.language = param.setting.language
    state.login = Object.assign(state.login, param.login)
}
export const UPDATE_LANG = (state, param) => {
    state.setting.language = param
}